module.exports = __webpack_public_path__ + "img/user-admin.f2e42361.svg";